export enum IconSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
